export const MediaTypes = {
    SET_MEDIATYPES: "SET_MEDIATYPES",
    ADD_MEDIATYPES: "ADD_MEDIATYPES",
    UPDATE_MEDIATYPES: "UPDATE_MEDIATYPES",
    DELETE_SELECTED_MEDIATYPES: "DELETE_SELECTED_MEDIATYPES",

}